import React, { Component } from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import { authCheck, logout } from "./store/SignIn/SignIn.Actions";

import "./App.css";

import SignInLayout from "./hoc/Layouts/SignInLayout/SignInLayout";
import MainLayout from "./hoc/Layouts/MainLayout/MainLayout";

import SignIn from "./containers/SignIn/SignIn";
import Dashboard from "./containers/Dashboard/Dashboard";
import UsersIndex from "./containers/Users/Index/Index";
import UsersView from "./containers/Users/View/View";
import UsersCreate from "./containers/Users/Create/Create";
import UsersUpdate from "./containers/Users/Update/Update";
import StatementRequestsIndex from "./containers/StatementRequests/Index/Index";
import StatementRequestsUpdate from "./containers/StatementRequests/Update/Update";
import InvoicesIndex from "./containers/Invoices/Index/Index";
import InvoicesCreate from "./containers/Invoices/Create/Create";
import InvoicesUpdate from "./containers/Invoices/Update/Update";
import OffersIndex from "./containers/Offers/Index/Index";
import OffersInterestsIndex from "./containers/OffersInterests/Index/Index";
import OffersInterestsUpdate from "./containers/OffersInterests/Update/Update";
import CallRequestsIndex from "./containers/CallRequests/Index/Index";
import CallRequestsUpdate from "./containers/CallRequests/Update/Update";
import TicketsIndex from "./containers/Tickets/Index/Index";
import TicketsCreate from "./containers/Tickets/Create/Create";
import TicketsView from "./containers/Tickets/View/View";
import AdminsIndex from "./containers/Admins/Index/Index";
import AdminsCreate from "./containers/Admins/Create/Create";
import AdminsUpdate from "./containers/Admins/Update/Update";
import BrokersIndex from "./containers/Brokers/Index/Index";
import BrokersHeadingsIndex from "./containers/BrokersHeadings/Index/Index";
import ProfitLossTypesIndex from "./containers/ProfitLossTypes/Index/Index";
import ChangePassword from "./containers/ChangePassword/ChangePassword";

class App extends Component {
  componentDidMount() {
    this.props.onAutoSignIn();
  }

  render() {
    let routes = (
      <Switch>
        <SignInLayout path="/" component={SignIn} />
      </Switch>
    );

    if (this.props.isAuthenticated) {
      routes = (
        <Switch>
          <MainLayout path="/" exact component={Dashboard} />
          <MainLayout path="/users" exact component={UsersIndex} />
          <MainLayout path="/users/:id/view" exact component={UsersView} />
          <MainLayout path="/users/create" exact component={UsersCreate} />
          <MainLayout path="/users/:id/edit" exact component={UsersUpdate} />
          <MainLayout
            path="/statement-requests"
            exact
            component={StatementRequestsIndex}
          />
          <MainLayout
            path="/statement-requests/:id/edit"
            exact
            component={StatementRequestsUpdate}
          />
          <MainLayout path="/invoices" exact component={InvoicesIndex} />
          <MainLayout
            path="/invoices/create"
            exact
            component={InvoicesCreate}
          />
          <MainLayout
            path="/invoices/:id/edit"
            exact
            component={InvoicesUpdate}
          />
          <MainLayout path="/tickets" exact component={TicketsIndex} />
          <MainLayout path="/tickets/create" exact component={TicketsCreate} />
          <MainLayout path="/tickets/:id/view" exact component={TicketsView} />
          <MainLayout path="/offers" exact component={OffersIndex} />
          <MainLayout
            path="/offers-interests"
            exact
            component={OffersInterestsIndex}
          />
          <MainLayout
            path="/offers-interests/:id/edit"
            exact
            component={OffersInterestsUpdate}
          />
          <MainLayout
            path="/call-requests"
            exact
            component={CallRequestsIndex}
          />
          <MainLayout
            path="/call-requests/:id/edit"
            exact
            component={CallRequestsUpdate}
          />
          <MainLayout path="/admins" exact component={AdminsIndex} />
          <MainLayout path="/admins/create" exact component={AdminsCreate} />
          <MainLayout path="/admins/:id/edit" exact component={AdminsUpdate} />
          <MainLayout path="/brokers" exact component={BrokersIndex} />
          <MainLayout
            path="/brokers-headings"
            exact
            component={BrokersHeadingsIndex}
          />
          <MainLayout
            path="/profit-loss-types"
            exact
            component={ProfitLossTypesIndex}
          />
          <MainLayout path="/change-password" component={ChangePassword} />
          <MainLayout path="/logout" component={logout} />
        </Switch>
      );
    }

    return routes;
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.SignIn.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAutoSignIn: () => dispatch(authCheck()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
